// extracted by mini-css-extract-plugin
export default {"tabBarWrapper":"styles_tabBarWrapper__AC9Tw"};